import  Button from "../../../shared/CustomButton";
import { Formik } from "formik";
import * as Yup from "yup";
import TextInput from "../../../shared/TextInput";  
import DropdownField from "../../../shared/DropdownField";
import DatePicker from "../../../shared/DatePicker";
import { useTranslation } from "react-i18next";
import { FaCalendarAlt } from "react-icons/fa";
import CheckPermission from "../../../hooks/CheckPermission";
export default function AddSubstoreReturn({ onClose, onSubmit }) {
  const { hasPermission } = CheckPermission();
  const { t } = useTranslation();
  const initialValues = {
    returnDate: null,
    returnBy: "",
    substore: "",
    status: "",
    receivedBy: "",
    receivedDate: null,
    remarks: "",
  };
  const validationSchema = Yup.object().shape({ 
    returnDate: Yup.date().nullable().required(t("Return Date is required")),
    returnBy: Yup.string().required(t("Return By is required")),
    substore: Yup.string().required(t("Substore is required")), 
    status: Yup.string().required(t("Status is required")),
    receivedBy: Yup.string().required(t("Received By is required")),
    receivedDate: Yup.date().nullable().required(t("Received Date is required")),
    remarks: Yup.string().required(t("Remarks are required")),
  });   
    const handleSubmit = (values, { resetForm }) => {
    if (!hasPermission('inventory', 'create')) return;
        // Convert dates to string format to avoid circular reference issues
        const formattedValues = {
            ...values,
            returnDate: values.returnDate ? new Date(values.returnDate).toLocaleDateString() : '',
            receivedDate: values.receivedDate ? new Date(values.receivedDate).toLocaleDateString() : '',
        };
        onSubmit(formattedValues);
        resetForm();
        onClose();
    }
    return (
    <div className="bg-white rounded-lg shadow-sm p-6 max-w-4xl mx-auto">
        <div className="mb-6">
            {/* <h2 className="text-2xl font-bold text-gray-800 border-b-2 border-blue-500 pb-2">
            {t("Add Substore Return")}
            </h2> */}
            <p className="text-gray-600 text-sm mt-2">
            {t("Fill in the details to create a new substore return record")}
            </p>
        </div>
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                isSubmitting,
            }) => (
            <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <DatePicker
                            name="returnDate"
                            label={t("Return Date")}
                            placeholder={t("Select Return Date")}
                            value={values.returnDate}
                            onChange={(value) => setFieldValue("returnDate", value)}
                            onBlur={handleBlur}
                            className="w-full"
                            inputClassName="w-full"
                            showIcon={<FaCalendarAlt className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />}
                        />
                        {errors.returnDate && touched.returnDate && (   
                            <div className="text-red-500 text-sm mt-1">{errors.returnDate}</div>
                        )}
                    </div>
                    <TextInput
                        name="returnBy"
                        label={t("Return By")}
                        value={values.returnBy}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="w-full"
                    />  
                    {errors.returnBy && touched.returnBy && (
                        <div className="text-red-500 text-sm mt-1">{errors.returnBy}</div>
                    )} 
                    <div>
                        <DropdownField
                            name="substore"
                            label={t("Substore")}
                            placeholder={t("Select Substore")}
                            options={[
                                { value: "", label: t("Select Substore") },
                                { value: "Main warehouse", label: "Main Warehouse" },
                                { value: "Pharmacy store", label: "Pharmacy Store" },
                                { value: "Lab storage", label: "Lab Storage" },
                                { value: "Emergency stock", label: "Emergency Stock" },

                            ]}
                            optionValue="value"
                            optionLabel="label"
                            value={values.substore}
                            onChange={(e) => setFieldValue("substore", e.value)}
                            onBlur={handleBlur}
                            className="w-full"
                        />
                        {errors.substore && touched.substore && (

                            <div className="text-red-500 text-sm mt-1">{errors.substore}</div>
                        )}
                    </div>  
                    <div>
                        <DropdownField
                            name="status"
                            label={t("Status")}
                            placeholder={t("Select Status")}
                            options={[
                                { value: "", label: t("Select Status") },
                                { value: "Pending", label: "Pending" },
                                { value: "Completed", label: "Completed" },
                                { value: "Cancelled", label: "Cancelled" },
                            ]}
                            optionValue="value"
                            optionLabel="label"
                            value={values.status}
                            onChange={(e) => setFieldValue("status", e.value)}
                            onBlur={handleBlur}
                            className="w-full"
                        />
                        {errors.status && touched.status && (
                            <div className="text-red-500 text-sm mt-1">{errors.status}</div>
                        )}  
                    </div>
                    <TextInput
                        name="receivedBy"
                        label={t("Received By")}
                        value={values.receivedBy}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="w-full"
                    />  
                    {errors.receivedBy && touched.receivedBy && (
                        <div className="text-red-500 text-sm mt-1">{errors.receivedBy}</div>
                    )}
                    <div>
                        <DatePicker
                            name="receivedDate"
                            label={t("Received Date")}
                            placeholder={t("Select Received Date")}
                            value={values.receivedDate}
                            onChange={(value) => setFieldValue("receivedDate", value)}
                            onBlur={handleBlur}
                            className="w-full"
                            inputClassName="w-full"
                            showIcon={<FaCalendarAlt className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />}
                        />
                        {errors.receivedDate && touched.receivedDate && (   
                            <div className="text-red-500 text-sm mt-1">{errors.receivedDate}</div>
                        )}
                    </div>
                    <div className="md:col-span-2">
                        <TextInput
                            name="remarks"
                            label={t("Remarks")}
                            value={values.remarks}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="w-full"
                            textarea
                            rows={3}
                        />  
                        {errors.remarks && touched.remarks && ( 
                            <div className="text-red-500 text-sm mt-1">{errors.remarks}</div>
                        )}
                    </div>
                </div>
                <div className="mt-6 flex justify-end space-x-3">
                    <Button
                        type="button"
                        onClick={onClose}
                        className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded"
                    >
                        {t("Cancel")}
                    </Button>
                    {hasPermission('inventory', 'create') && (
                    <Button
                        type="submit"
                        disabled={isSubmitting}
                        className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
                    >
                        {t("Submit Return")}
                    </Button>
                    )}
                </div>
            </form> 
            )}
        </Formik>
    </div>
  );
} 
